module.exports = __webpack_public_path__ + "canary-islands.svg?84ef5084c3845bdb84d93e9510aa987e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/canary-islands.svg
// module id = 128
// module chunks = 10